/**
 * Generate a UUID with fallback for older browsers
 *
 * Uses crypto.randomUUID() if available (modern browsers),
 * falls back to RFC4122 v4 UUID implementation for older browsers
 * like Safari < 15.4, Chrome < 92, Firefox < 95
 */
export function generateUUID(): string {
  // Use native crypto.randomUUID() if available
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // Fallback implementation for older browsers
  // RFC4122 version 4 UUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
